// extracted by mini-css-extract-plugin
module.exports = {"hideTokensHeader":"styles_hideTokensHeader__TAiCo","wrapper":"styles_wrapper__9V_ep"};